// API imports
import { getKeyFactors } from '../../../../api/games';

export const getRoundTo = statId => {
    return statId === 'obp' ||
        statId === 'era' ||
        statId === 'babip' ||
        statId === 'avg' ||
        statId === 'slg' ||
        statId === 'fpct' ||
        statId === 'whip' ||
        statId === 'xfip'
        ? 3
        : statId === 'astTo' || statId === 'offEff' || statId === 'defEff' || statId === 'Earned Run Average' || statId === 'Walks Plus Hits Per Inning Pitched'
          ? 2
          : 1;
};

export const keyFactorData = async (sport, teamData, oppData, type = 'off', oppType = 'off') => {
    sport = String(sport).toLowerCase();
    var fieldsArray = await getKeyFactors(sport);
    if (!Array.isArray(fieldsArray)) {
        fieldsArray = Array.isArray(fieldsArray?.data) ? fieldsArray.data : [];
    }
    var labels = [];

    // For pitcher/pitching types, return separate awayFactors and homeFactors without comparison
    if (type === 'pitcher' || type === 'pitching') {
        var awayFactors = [];
        var homeFactors = [];

        fieldsArray
            .filter(field => field.type === type)
            .forEach(field => {
                var roundTo = getRoundTo(field.id);
                labels.push(field.label);
                const suffix = field.suffix ? field.suffix : '';

                // Away team stats
                let awayValue = 0;
                if (type === 'pitcher') {
                    awayValue = teamData.pitcher?.stats?.[field.id] || 0;
                } else {
                    awayValue = teamData.stats?.[type]?.[field.id] || 0;
                }

                // Home team stats
                let homeValue = 0;
                if (type === 'pitcher') {
                    homeValue = oppData.pitcher?.stats?.[field.id] || 0;
                } else {
                    homeValue = oppData.stats?.[type]?.[field.id] || 0;
                }

                // Compare values to determine class (but each team gets their own independent factors)
                let awayClass = 'light';
                let homeClass = 'light';

                if (awayValue !== homeValue) {
                    if (field.winner === 'gt') {
                        awayClass = awayValue > homeValue ? 'success' : 'danger';
                        homeClass = homeValue > awayValue ? 'success' : 'danger';
                    } else if (field.winner === 'lt') {
                        awayClass = awayValue < homeValue ? 'success' : 'danger';
                        homeClass = homeValue < awayValue ? 'success' : 'danger';
                    }
                }

                awayFactors.push({
                    value: awayValue !== 'N/A' ? `${awayValue.toFixed(roundTo)}${suffix}` : awayValue,
                    class: awayClass,
                    label: field.label,
                });

                homeFactors.push({
                    value: homeValue !== 'N/A' ? `${homeValue.toFixed(roundTo)}${suffix}` : homeValue,
                    class: homeClass,
                    label: field.label,
                });
            });

        return { awayFactors, homeFactors, labels };
    }

    // For team comparisons (off vs def), return single teamFactors
    var teamFactors = [];
    fieldsArray
        .filter(field => field.type === type)
        .forEach(field => {
            var result = assignAdvantage(field, teamData, oppData, type, oppType, fieldsArray);
            var roundTo = getRoundTo(field.id);
            labels.push(field.label);
            const suffix = field.suffix ? field.suffix : '';
            teamFactors.push({
                value: result.teamFactor !== 'N/A' ? `${result.teamFactor.toFixed(roundTo)}${suffix}` : result.teamFactor,
                class: result.teamClass,
                label: field.label,
            });
        });
    return { teamFactors, labels };
};

const assignAdvantage = (field, teamData, oppData, teamType, oppType, fieldsArray) => {
    let data = {
        teamFactor: 0,
        teamClass: 'light',
        oppFactor: null,
    };

    // Get this team's factor value based on their selected type
    if (teamType === 'pitcher') {
        data.teamFactor = teamData.pitcher?.stats?.[field.id] || 0;
    } else {
        data.teamFactor = teamData.stats?.[teamType]?.[field.id] || 0;
    }
    // Find the opponent's field with the same label
    const oppField = fieldsArray.find(f => f.type === oppType && f.label === field.label);
    if (oppField) {
        if (oppType === 'pitcher') {
            if (oppData.pitcher?.stats && oppField.id in oppData.pitcher.stats) {
                data.oppFactor = oppData.pitcher.stats[oppField.id];
            }
        } else {
            if (oppData.stats?.[oppType] && oppField.id in oppData.stats[oppType]) {
                data.oppFactor = oppData.stats[oppType][oppField.id];
            }
        }
    }

    // Check if oppFactor exists and is a valid number (including 0)
    const hasValidComparison = data.oppFactor !== null && data.oppFactor !== undefined;
    if (hasValidComparison && oppField) {
        const isOppositeTypes = (teamType === 'off' && oppType === 'def') || (teamType === 'def' && oppType === 'off');
        if (isOppositeTypes) {
            // When comparing off vs def, show who has the advantage in the matchup
            // Example: Offense scores 21.9, Defense allows 31.3
            // - Offense: 21.9 < 31.3 → SUCCESS (room to score more than usual)
            // - Defense: 31.3 > 21.9 → DANGER (allows more than offense usually scores)
            if (field.winner === 'gt') {
                // Team is offense (wants higher) - advantage if team < opp
                data.teamClass = data.teamFactor === data.oppFactor ? 'light' : data.teamFactor < data.oppFactor ? 'success' : 'danger';
            } else if (field.winner === 'lt') {
                // Team is defense (wants lower) - advantage if team < opp (allows less than offense scores)
                data.teamClass = data.teamFactor === data.oppFactor ? 'light' : data.teamFactor < data.oppFactor ? 'success' : 'danger';
            }
        } else {
            // Same type comparison (off vs off, def vs def, pitching vs pitching)
            if (field.winner === 'gt') {
                data.teamClass = data.teamFactor === data.oppFactor ? 'light' : data.teamFactor > data.oppFactor ? 'success' : 'danger';
            } else if (field.winner === 'lt') {
                data.teamClass = data.teamFactor === data.oppFactor ? 'light' : data.teamFactor < data.oppFactor ? 'success' : 'danger';
            }
        }
    }

    return data;
};
